<template>
  <div class="line-items-footer-item line-items-footer-item-highlighted line-items-footer-item-last px-i">
    <div class="line-items-footer-item-start">
      TOTAL
    </div>

    <div class="line-items-footer-item-end footer-item-total-amount-js">
      {{ totalAmount | formatCurrency(selectedCurrency.iso_code) }}
      <input v-model="totalAmount" type="hidden" name="invoice[total]">
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("lineItems", [
      "selectedCurrency",
      "totalAmount"
    ])
  }
};
</script>
